export default __webpack_public_path__ + "static/media/join_visit_icon.e8537fef.svg";